var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"page"},[_c('h4',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.titles[0])+" > ")]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.titles[1])+" ")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }